import { Component, Input } from '@angular/core';
import { NavParams } from 'ionic-angular';
import { ViewController } from 'ionic-angular';
import { UtilsProvider } from '../../providers/utils/utils';

@Component({
  selector: 'scheduler-modal-page',
  templateUrl: 'scheduler-modal.html',
})
export class SchedulerModalPage {
  installers: any[];
  constructor(public viewCtrl: ViewController, params: NavParams, private utilsProvider: UtilsProvider) {
    this.installers = params.get('installers');
  }

  cancel() {
    this.dismissModal();
  }

  dismissModal() {
    this.viewCtrl.dismiss(null);
  }

  selectInstaller(item){
    this.viewCtrl.dismiss(item);
  }
}



// WEBPACK FOOTER //
// ./src/pages/scheduler-modal/scheduler-modal.ts